export interface GalleryImage {
  id: string;
  url: string;
  alt?: string;
}

export const galleryImages: GalleryImage[] = [
  { id: '1', url: '/images/StockSnap_6ZYX4YY4IR.jpg', alt: 'Community event 1' },
  { id: '2', url: '/images/StockSnap_KBZCTLSNWU.jpg', alt: 'Children’s class' },
  { id: '3', url: '/images/StockSnap_OT37RD9KJN.jpg', alt: 'Mass service' },
  { id: '4', url: '/images/gallery4.jpg', alt: 'Volunteer group' },
];
